import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import Endpoints from "../../../domain/endpoints";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY,  } from "../../../base";
import { FetchState } from "../../../domain/models/fetch-state";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import { FetchBaseBrickLocationType } from "../../../domain/models/brick-management-report/brick-management-data";
import { FetchBaseBrickLocation } from "../../../domain/useages/brick-management/fetch-base-brick-location";
import { RemoteFetchBaseBrickLocation } from "../../../data/usecases/brick-management/remote-fetch-base-brick-location";

export interface FetchBaseBrickLocationInterface {
  FetchBaseBrickLocation: FetchBaseBrickLocationType;
  FetchBaseBrickLocationState: FetchState;
  fetchBaseBrickLocation: Function;
}

const initialStates = {
  FetchBaseBrickLocation: {} as FetchBaseBrickLocationType,
  FetchBaseBrickLocationState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchBaseBrickLocationSlice: StateCreator<
  FetchBaseBrickLocationInterface
> = (set) => ({
  ...initialStates,
  fetchBaseBrickLocation: async (params: FetchBaseBrickLocation.Params) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchBaseBrickLocation = new RemoteFetchBaseBrickLocation(
      `${BASE_URL}${Endpoints.FETCH_BASE_BRICK_LOCATION}`,

      axiosHttpClient
    );

    set(() => ({ FetchBaseBrickLocationState: FetchState.LOADING }));
    let result = await remoteFetchBaseBrickLocation.fetch(params);
    return result;
  },
});
